let LocalStorageHelper = function () {
    this.getItem = function (key) {
        try {
            return JSON.parse(localStorage.getItem(key));
        } catch (e) {
            return localStorage.getItem(key);
        }
    };

    this.setItem = function (key, data) {
        try {
            return localStorage.setItem(key, JSON.stringify(data));
        } catch (e) {
            return localStorage.setItem(key, data);
        }
    };

    this.removeItem = function (key) {
        localStorage.removeItem(key);
    };

    this.clear = function () {
        localStorage.clear();
    }

};

let localStorageHelper = new LocalStorageHelper();

export default localStorageHelper;



// WEBPACK FOOTER //
// ./src/localStorageHelper.js